import $ from "jquery";

class Loading {

  showLoadingAnimation = () => {
    $("#loading-animation").fadeIn();
  };

  hideLoadingAnimation = () => {
    $("#loading-animation").fadeOut();
  };
}

export default Loading;
